import { Component, inject, ViewChild } from '@angular/core';
import { getIdToken } from '@angular/fire/auth';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { BaseComponent } from '../../shared/base.component';
import { AddDealerRepState } from '../../shared/state-interface';
import { SiteHeaderComponent } from '../../site-header/site-header.component';
import { DealerRepComponent } from '../shared/dealer-rep.component';
import { DealerRep } from '../shared/dealer-rep.model';
import { DealerRepService } from '../shared/dealer-rep.service';

@Component({
    selector: 'app-add-rep-dealer',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        SiteHeaderComponent,
        DealerRepComponent
    ],
    templateUrl: './add-dealer-rep.component.html',
    styleUrl: './add-dealer-rep.component.css'
})
export class AddDealerRepComponent extends BaseComponent {

    @ViewChild(DealerRepComponent) dealerRepComponent!:DealerRepComponent;

    private dealerRepService: DealerRepService = inject(DealerRepService);

    private static _addingDealerRep = "Adding DealerRep";
    private static _addingDealerRepError = `${AddDealerRepComponent._addingDealerRep} error:`;

    public ngAfterViewInit() {
        const state: AddDealerRepState | undefined = this.stateManager.addDealerRepState;
        
        if (state != undefined) {
            this.dealerRepComponent.restoreState(state.dealerRepComponentState);
            super.restoreState(state.baseComponentState);
        }
    }

    public ngOnDestroy() {
        const state: AddDealerRepState = {} as AddDealerRepState;
        state.dealerRepComponentState = this.dealerRepComponent.getState();
        state.baseComponentState = super.getState();
        this.stateManager.addDealerRepState = state;
    }

    protected cancel() {
        this.router.navigate(["/view-dealer-reps"], { state: { restore: true } });
    }

    protected async save() {
        const currentUser = this.auth.currentUser;

        if (currentUser) {
            const dealerRep: DealerRep = this.dealerRepComponent.createModelFromForm(new DealerRep());

            const observable = await this.dealerRepService.addDealerRep(await getIdToken(currentUser), dealerRep);
            this.message = "";
            super.showSnackBar(`${AddDealerRepComponent._addingDealerRep}...`, -1);

            observable.subscribe(response => {
                try {
                    const json = JSON.parse(JSON.stringify(response));
                    if (json["add-dealer-rep"] == "success") {
                        const queryParam = `DealerRep '${dealerRep.first_name} ${dealerRep.last_name}' added.`;
                        this.router.navigate(["/view-dealer-reps"], { queryParams: {"overrideSnackBar": queryParam}, state: { refresh: true } });
                    } else {
                        throw new Error(json["message"]);
                    }
                } catch (error) {
                    const message = `${AddDealerRepComponent._addingDealerRepError} ${(<Error>error).message}`;
                    this.message = message;
                    super.dismissSnackBar();
                }
            })
        } else {
            const message = `${AddDealerRepComponent._addingDealerRepError} Null user instance`;
            console.error(message)
            super.showSnackBar(message, 30);
        }
    }
}
